import { useAppAPIKeyRevoke } from "@/api";
import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { toast } from "@/components/ui/use-toast";
import { Dispatch, SetStateAction } from "react";
import { APIKey } from "../../types/app.type";

interface Props {
  apiKey: APIKey;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

function RevokeAPIKey({ apiKey, setOpen }: Props) {
  const [revokeAPIKey] = useAppAPIKeyRevoke({
    apiKeyID: apiKey.id,
    appSlug: apiKey.appSlug,
    subscriptionId: apiKey.appSubscriptionId,
    origin: apiKey.appOrigin
  });

  function handleDelete() {
    revokeAPIKey()
      .then(() =>
        toast({
          title: "API key revoked"
        })
      )
      .catch((error) => {
        toast({
          title: "Unable to revoke API key",
          description:
            "An error occurred while trying to revoke the API key. Please try again later."
        });
        console.error(error);
      });
    setOpen(false);
  }

  return (
    <Dialog.Root open onOpenChange={setOpen}>
      <Dialog.Content className="max-w-lg dark:bg-brand-gray-900">
        <Dialog.Header className="space-y-2">
          <Dialog.Title className="leading-5 text-brand-gray-800 dark:text-brand-gray-100">
            Revoke API key
          </Dialog.Title>
          <Dialog.Description className="text-brand-gray-700 dark:text-brand-gray-300">
            Are you sure you want to revoke the API key{" "}
            <span className="font-semibold">{apiKey.name}</span>?
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer className="mt-8">
          <Dialog.Close asChild>
            <Button variant="secondary">Cancel</Button>
          </Dialog.Close>
          <Button variant="destructive" onClick={handleDelete}>
            Revoke
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}

export default RevokeAPIKey;
